// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"407":"panel","441":"superadmin","785":"panel-senat","884":"admin","933":"auth","974":"senat-admin"}[chunkId] || chunkId) + "." + {"70":"03786ad2","148":"afae89de","306":"2167de01","364":"7a5e8742","407":"bb6f0d83","441":"1c00d573","785":"af809205","884":"47a605a5","933":"bf733971","974":"cc36d7b5"}[chunkId] + ".js";
};